(function(){
  var NS='http://www.w3.org/2000/svg';
  function el(n,a){var e=document.createElementNS(NS,n);for(var k in a)e.setAttribute(k,a[k]);return e;}
  function rand(s){return function(){s=(s*9301+49297)%233280;return s/233280;};}
  function build(box){
    var W=box.clientWidth,H=box.clientHeight;if(!W||!H)return;
    var old=box.querySelector('svg.mie-lights__svg');if(old)old.remove();
    var r=rand(7),mobile=W<750;
    var svg=el('svg',{'class':'mie-lights__svg',width:W,height:H,viewBox:'0 0 '+W+' '+H,'aria-hidden':'true',focusable:'false'});
    var id='g'+Math.floor(Math.random()*1e6);
    var defs=el('defs',{});
    var rg=el('radialGradient',{id:id+'b',cx:'45%',cy:'40%',r:'65%'});
    rg.appendChild(el('stop',{offset:'0','stop-color':'#fffbe9'}));
    rg.appendChild(el('stop',{offset:'.55','stop-color':'#ffe2a1'}));
    rg.appendChild(el('stop',{offset:'1','stop-color':'#e9a94d'}));
    var gl=el('radialGradient',{id:id+'g'});
    gl.appendChild(el('stop',{offset:'0','stop-color':'#ffd98c','stop-opacity':'.75'}));
    gl.appendChild(el('stop',{offset:'.4','stop-color':'#ffc96a','stop-opacity':'.28'}));
    gl.appendChild(el('stop',{offset:'1','stop-color':'#ffc96a','stop-opacity':'0'}));
    defs.appendChild(rg);defs.appendChild(gl);svg.appendChild(defs);
    function swag(y0,sag,dir,seg,offset,spacing){
      var wires=el('g',{fill:'none',stroke:'rgba(20,32,28,.85)','stroke-width':'1.3'});
      var bulbs=el('g',{});
      for(var x=-offset;x<W+seg;x+=seg){
        var x0=x,x1=x+seg,cx=x+seg/2,cy=y0+2*sag*dir;
        wires.appendChild(el('path',{d:'M'+x0+' '+y0+' Q'+cx+' '+cy+' '+x1+' '+y0}));
        var n=Math.max(3,Math.round(seg/spacing));
        for(var i=1;i<n;i++){
          var t=i/n,px=(1-t)*(1-t)*x0+2*(1-t)*t*cx+t*t*x1,py=(1-t)*(1-t)*y0+2*(1-t)*t*cy+t*t*y0;
          if(px<-10||px>W+10)continue;
          var tx=2*(1-t)*(cx-x0)+2*t*(x1-cx),ty=2*(1-t)*(cy-y0)+2*t*(y0-cy);
          var ang=Math.atan2(ty,tx)*180/Math.PI+(dir<0?180:0)+(r()-.5)*16;
          var g=el('g',{transform:'translate('+px.toFixed(1)+' '+py.toFixed(1)+') rotate('+ang.toFixed(1)+')'});
          var s=mobile?.8:1;
          var b=el('g',{'class':'mie-lights__bulb',style:'animation-delay:-'+(r()*6).toFixed(2)+'s;animation-duration:'+(3+r()*4).toFixed(2)+'s'});
          b.appendChild(el('circle',{cx:0,cy:9*s,r:16*s,fill:'url(#'+id+'g)'}));
          b.appendChild(el('ellipse',{cx:0,cy:9*s,rx:3.6*s,ry:5.6*s,fill:'url(#'+id+'b)'}));
          g.appendChild(el('rect',{x:-2.3*s,y:1*s,width:4.6*s,height:3.6*s,rx:.8,fill:'#2b2f2a'}));
          g.appendChild(b);
          bulbs.appendChild(g);
        }
      }
      svg.appendChild(wires);svg.appendChild(bulbs);
    }
    var slim=box.getAttribute('data-mie-lights')==='slim';
    var seg=mobile?190:330,sp=mobile?30:34;
    if(slim){swag(-2,Math.min(12,H*.14),1,mobile?150:240,mobile?50:90,mobile?28:30);}
    else{
    swag(-2,Math.min(30,H*.16),1,seg,seg*.35,sp);
    swag(-6,Math.min(46,H*.26),1,seg*1.35,seg*.9,sp+4);
    }
    box.insertBefore(svg,box.firstChild);
  }
  function init(){
    document.querySelectorAll('[data-mie-lights]').forEach(function(b){
      build(b);
      if(window.ResizeObserver){var t;new ResizeObserver(function(){clearTimeout(t);t=setTimeout(function(){build(b);},150);}).observe(b);}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
